import React from "react";
import { get, titleCase } from "sites-common/utils/lodash";
import {
  doFormatShortDate,
  formatSys2OdooDate,
} from "@heartfulnessinstitute/react-hfn-forms/dist/formatting";
import { daysDiff } from "@heartfulnessinstitute/react-hfn-forms/dist/utils";
import { Div } from "../../components/Bootstrap";
// import { patientsDocumentsUrl } from "../../urls";
import { DocumentsButton, SittingsButton } from "../../common1/buttons";

const strings = require("../../care-app/strings.json");

const today = formatSys2OdooDate(new Date());

export const RenderColumns = (primaryKey, trainersMap) => [
  ["Name", (r) => titleCase(r.name)],
  ["Gender / Age", ["gender", "age"]],
  ["City", (r) => titleCase(r.city)],
  ["State / Country", ["state", "country"]],
  [
    "Added On",
    (item) => (
      <div>
        {doFormatShortDate(item.added_on)}
        <div>
          <small>{daysDiff(today, item.added_on)} days ago</small>
        </div>
      </div>
    ),
  ],
  [
    "Status",
    (item) => (
      <Div
        className={`badge ${
          item.status === "discontinued"
            ? "badge-danger"
            : item.status === "expired"
            ? "badge-info"
            : "badge-success"
        }`}
      >
        {strings.status_opts[item.status]}
      </Div>
    ),
  ],
  [
    "Last Sitting Date",
    (item) => (
      <div>
        <Div
          className={`mr-1 badge ${
            !item.last_sitting_date ? "badge-danger" : "badge-success"
          }`}
        >
          {item.last_sitting_date} {item.last_sitting_type}
        </Div>
        {item.last_sitting_date !== "" && (
          <div>
            <small>{item.last_sitting_days} days ago</small>
          </div>
        )}
      </div>
    ),
  ],
  [
    "Trainers",
    (item) => (
      <div>
        {get(item, "caretrainers", []).map((trainer) => (
          <div key={trainer}>{get(trainersMap, trainer, trainer)}</div>
        ))}
      </div>
    ),
  ],
  [
    "Documents",
    (item, passConfig) => (
      <DocumentsButton
        item={item}
        passConfig={passConfig}
        btnProps={{ text: "View", iconProps: { iconName: "Source" } }}
      />
    ),
  ],
  [
    "Sittings",
    (item, passConfig) => (
      <SittingsButton
        item={item}
        passConfig={passConfig}
        btnProps={{ text: "Journal", iconProps: { iconName: "People" } }}
      />
    ),
  ],
  ["Added By", (r) => r.added_by_name || "-"],
];

export const excelColumns = (pk, trainersMap) => [
  ["Name", (r) => titleCase(r.name)],
  ["Age", "age"],
  ["Gender", "gender"],
  ["City", (r) => titleCase(r.city)],
  ["State / Country", ["state", "country"]],
  ["ID Number", "abhyasiid"],
  ["Email", "email"],
  ["Mobile", "mobile"],
  ["Phone 2", "phone2"],
  [
    "Assigned Trainers",
    (item) =>
      get(item, "caretrainers", [])
        .map((trainer) => get(trainersMap, trainer, trainer))
        .join(" -- "),
  ],
  ["Problem", "problem"],
  ["Referred By", ["referred_by", "referred_by_other"]],
  ["Polarity", "polarity"],
  ["Status", "status"],
  ["Last Sitting Date", "last_sitting_date"],
  ["Last Sitting Type", "last_sitting_type"],
];
